/**
 * On Course Approach Reducers
 */
import {
    OCTAPPROACH_ACTION,
    ALL_OCTAPPROACH,
    ALL_OCTCLUBSPEED,
    ADD_OCTAPPROACH,
    FETCH_OCTAPPROACH,
    EDIT_OCTAPPROACH,
    DELETE_OCTAPPROACH,
    FETCH_OCTAPPROACHCHART,
    FETCH_APPROACHSHOTCHART,
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    octapproachlist:[],
    octcluspeedlist:[],
    particularoctapproach:[],
    approachchart:[],
    approachshotchart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case OCTAPPROACH_ACTION:
            return { ...state, loading: true };       

        case ALL_OCTAPPROACH:
            return { ...state, loading: false, octapproachlist: action.payload };   
            
        case ALL_OCTCLUBSPEED:
            return { ...state, loading: false, octcluspeedlist: action.payload };   
            
        case ADD_OCTAPPROACH:
            return { ...state, loading: false };     
         
        case FETCH_OCTAPPROACH:
            return { ...state, loading: false, particularoctapproach: action.payload };  
            
        case EDIT_OCTAPPROACH:
             return { ...state, loading: false }; 
            
        case DELETE_OCTAPPROACH:
            return { ...state, loading: false };
            
        case FETCH_OCTAPPROACHCHART:
            return { ...state, loading: false, approachchart: action.payload }; 
            
        case FETCH_APPROACHSHOTCHART:
            return { ...state, loading: false, approachshotchart: action.payload }; 
        
        default: return { ...state };

     }
 }